/* eslint-disable import/prefer-default-export */
import { getImageInfo } from "../utils/preload-image";

export async function createPreview(area, sideKey) {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const {
    image: backdropImage,
    width,
    height
  } = await getImageInfo(area.backdropUrl, { crossOrigin: "anonymous" });
  const { image: artworkImage } = await getImageInfo(area.artworkUrl, { crossOrigin: "anonymous" });

  ctx.canvas.width = width;
  ctx.canvas.height = height;
  ctx.clearRect(0, 0, width, height); // clear canvas
  ctx.drawImage(backdropImage, 0, 0, width, height);

  const angle = (area.rotation * Math.PI) / 180;
  const [x, y] = area.center;
  ctx.save();
  ctx.translate(x * -angle, y * angle);
  ctx.rotate(-angle);
  ctx.drawImage(artworkImage, x - area.width / 2, y, area.width, area.height);
  ctx.restore();

  return new Promise(resolve => {
    canvas.toBlob(blob => {
      const file = new File([blob], `${sideKey}-${Date.now()}.png`, {
        type: "image/png"
      });
      resolve({
        dataUrl: canvas.toDataURL(),
        file
      });
    });
  });
}
